var onlineTestDraftSaved = false;
var onlineTestUpdated = false;
var onlineTestSubmitted = false;

(function( $ ) {
    'use strict';

    $( window ).load(function() {
        if (window.location.pathname !== "/online-test/") {
            // only run this on the online-test page
            return;
        }

        let formElement = $('form.forminator-custom-form');
        let formTitle = $('h1');
        let saveDraftBtn = document.querySelector(".forminator-save-draft-link")
        let trackerBarsOnlineTest = document.querySelectorAll(".tracker-bar")
        let isLoggedIn = document.body.classList.contains("logged-in");
        let isSubscriptionPurchase = $('.single_variation_wrap').length > 0;
        let isMedicalQuestions = $('#forminator-module-7074, #forminator-module-9287').length > 0;
        let isPhotoUpload = $('#forminator-module-7075').length > 0;
        let timeoutHandle = null;

        $(window).bind('beforeunload', function() {
            if (onlineTestDraftSaved || !onlineTestUpdated || onlineTestSubmitted) {
                return;
            }

            return "Are you sure you want to leave without saving? Use the 'save as draft' option to continue later";
        });

        $("input").click(function() {
            onlineTestUpdated = true;
        });

        $("select").change(function() {
            onlineTestUpdated = true;
        });

        $('.forminator-save-draft-link').click(function() {
            onlineTestDraftSaved = true;
        });

        $(formElement).submit(function() {
            onlineTestSubmitted = true;
        });

        // when they haven't subscribed a purchase option is shown instead of the test,
        // if they click that button we don't want an "are you sure?" message to appear.
        // The same applies to:
        // - medical questions v2 (7074)
        // - medical questions v3 (9287)
        // - photo upload (7075)
        if (isSubscriptionPurchase || isMedicalQuestions || isPhotoUpload) {
            onlineTestSubmitted = true;
        }

        // if it's the photo upload then we want to display a "click here if it takes ages" message on submit
        if (isMedicalQuestions) {
            $('.forminator-button-submit').click(function() {
                timeoutHandle = setTimeout(
                    displayMessage,
                    20000,
                    [
                        "<p>This is taking some time to process, please <a href='/online-test/medical-history/complete'>click here to progress with your journey</a></p>"
                    ]
                );
            });
        }

        // if it's the photo upload then we want to display a "click here if it takes ages" message on submit
        if (isPhotoUpload) {
            $('.forminator-button-submit').click(function() {
                timeoutHandle = setTimeout(
                    displayMessage,
                    20000,
                    [
                        "<p>This is taking some time to process, please <a href='/online-test/patient-images/complete'>click here to progress with your journey</a></p>"
                    ]
                );
            });
        }

        // Hide the save draft button for guests
        if (saveDraftBtn) {
            saveDraftBtn.style.display = isLoggedIn ? "block" : "none";
        }

        if (trackerBarsOnlineTest) {
            trackerBarsOnlineTest.forEach((trackerBar) => {
                trackerBar.classList.add("hidden-tracker-bar");
            })
        }



        // clicking the 'next' button
        document.addEventListener(
            'click',
            async function (event) {
                if (!event.target.matches('.forminator-button-next')) {
                    return;
                }

                if (document.querySelector(".forminator-error-message")) {
                    // if there's an error then scroll to it
                    document.querySelector(".forminator-error-message").scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                        inline: "nearest",
                    });
                } else {
                    // if no error then scroll to the top of the page
                    window.scrollTo(0, 0);
                }
            }
        );

        /**
        const onlineTestInterval = setInterval(() => {
            const formOnlineTest = document.querySelector("#forminator-module-9286");
            const nextButton = document.querySelector(".forminator-button-next");
            if(!formOnlineTest || !nextButton) return;
            clearInterval(onlineTestInterval);
            nextButton.addEventListener("click", () => {
                const checkCurrentStep = (className) => {
                    return document.querySelector(".forminator-current").classList.contains(className)
                }

                if(checkCurrentStep("forminator-step-1")) {
                    callEventGtag("online_test_page1_complete_v2", { 'user_id': window.fbq.getState().pixels[0].userData.external_id })
                }

                if(checkCurrentStep("forminator-step-2")) {
                    callEventGtag("online_test_page2_complete_v2", { 'user_id': window.fbq.getState().pixels[0].userData.external_id })
                }

                if(checkCurrentStep("forminator-step-3")) {
                    callEventGtag("online_test_page3_complete_v2", { 'user_id': window.fbq.getState().pixels[0].userData.external_id })
                }

                if(checkCurrentStep("forminator-step-4")) {
                    callEventGtag("online_test_page4_complete_v2", { 'user_id': window.fbq.getState().pixels[0].userData.external_id })
                }
            })
        }, 200)
        */







        function displayMessage(messageHtml)
        {
            // remove any existing messages
            if (document.getElementById("klira-post-submit-message")) {
                document.getElementById("klira-post-submit-message").remove();
            }

            const wrapper = document.createElement("div");
            wrapper.setAttribute('id','klira-post-submit-message');
            wrapper.innerHTML = messageHtml;
            formElement.after(wrapper);
        }
    });

})( jQuery );
